import React from 'react';
import VideoEmbed from 'components/VideoEmbed';
import { videoShape } from 'utils/shapes';
import { htmlDecode } from 'utils/web';
import './VideoPlayer.css';

function VideoPlayer({ video }) {
  const date = new Date(video.publishedAt);
  const title = htmlDecode(video.title);

  return (
    <div className="video-player">
      <VideoEmbed
        key={video.videoId}
        videoId={video.videoId}
        title={title}
        deactivateOnEnd
      />
      <h3 className="video-title">{title}</h3>
      <div className="video-info clearfix">
        <div className="video-meta">
          <span className="meta-item video-publish-date">
            Published on {date.toDateString()}
          </span>
        </div>
      </div>
      <div className="video-description">
        <p>{video.description}</p>
      </div>
    </div>
  );
}

VideoPlayer.propTypes = {
  video: videoShape
};

export default VideoPlayer;
